import script from "./HomeSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeSlide.vue?vue&type=script&setup=true&lang=js"

import "./HomeSlide.vue?vue&type=style&index=0&id=c6aa7b3e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Veverica\\Documents\\projekti\\btc-prop\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6aa7b3e"]])

export default __exports__